import React from 'react';
import { Button, Divider, Grid, Typography } from '@rbx/ui';
import useDialogStyles from '@modules/miscellaneous/common/styles/Dialog.styles';

type TDialogTemplateVariant = 'center';

interface TDialogTemplateProps {
  title: string;
  content?: string;
  variant: TDialogTemplateVariant;
  confirmText: string;
  onConfirm: () => void;
}

const TDialogTemplate: React.FC<React.PropsWithChildren<TDialogTemplateProps>> = ({
  title,
  content,
  variant,
  confirmText,
  onConfirm,
}) => {
  const {
    classes: { container, content: contentStyle, divider, buttonWrapper },
  } = useDialogStyles();

  if (variant === 'center')
    return (
      <Grid className={container} container>
        <Grid item XSmall={12}>
          <Typography variant='h3' component='h3'>
            {title}
          </Typography>
          <Divider className={divider} />
          {content && (
            <Typography className={contentStyle} variant='body1' component='p'>
              {content}
            </Typography>
          )}
          <div className={buttonWrapper}>
            <Button onClick={onConfirm} variant='contained' color='primaryBrand'>
              {confirmText}
            </Button>
          </div>
        </Grid>
      </Grid>
    );

  throw new Error(`Invalid TDialogTemplate variant: ${variant}`);
};

export default TDialogTemplate;
